import React from 'react';
import Hero from './Hero';
import FeaturedHero from './FeaturedHero';
import LatestPosts from './LatestPosts';

const PostList = () => {
  return (
    <div>
      <Hero />
      <FeaturedHero />
      <LatestPosts />
    </div>
  );
};

export default PostList; 